import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Button, Collapse, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { selectFiles, updateFileField } from "../../../ReduxStore/UserSlice";
import DragDropFileUpload from "../FileUpload/DragDropFileUpload";
import { base64ToFile } from "../Util/Util";

const DirectorDocumentSet = ({
  index,
  control,
  errors,
  onRemove,
  defaultExpanded = false,
  validationRules = {},
  setValue,
  kycName = "Promoter",
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const toggleExpand = () => setIsExpanded(!isExpanded);

  const dispatch = useDispatch();
  const files = useSelector(selectFiles);

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleFileSelect = (type, index) => async (selectedFile) => {
    try {
      if (selectedFile) {
        const base64 = await fileToBase64(selectedFile);
        const fileData = {
          base64,
          filename: selectedFile.name,
        };
        dispatch(updateFileField({ field: type, index, value: fileData }));
      }
    } catch (error) {
      console.error("Failed to convert file to base64:", error);
    }
  };

  const convertAndSetFile = (fileData) => {
    if (fileData?.base64 && fileData?.filename) {
      return base64ToFile(fileData.base64, fileData.filename);
    } else if (
      fileData?.remote === true &&
      (fileData?.url || fileData?.documentPath)
    ) {
      return fileData;
    }
    return null;
  };
  useEffect(() => {
    setValue(
      `directors[${index}].pan`,
      convertAndSetFile(files?.panCard?.[index])
    );
    setValue(
      `directors[${index}].aadhar`,
      convertAndSetFile(files?.AadharCard?.[index])
    );
  }, []);

  return (
    <Box sx={{ mb: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
      <Box
        onClick={toggleExpand}
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
      >
        <Typography variant="h6">
          {index === 0
            ? `Upload ${kycName} KYC`
            : `Upload ${kycName} KYC ${index + 1}`}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {index > 0 && (
            <Button
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                onRemove(index);
              }}
              size="small"
            >
              Remove
            </Button>
          )}
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand();
            }}
          >
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>
      </Box>

      <Collapse in={isExpanded}>
        <Box sx={{ p: 3, borderTop: "1px solid #e0e0e0" }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* PAN Upload */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please upload the PAN card
              </Typography>
              <Controller
                name={`directors[${index}].pan`}
                control={control}
                rules={validationRules.pan}
                render={({ field }) => (
                  <DragDropFileUpload
                    name="panCard"
                    value={convertAndSetFile(files?.panCard?.[index])}
                    error={!!errors?.directors?.[index]?.pan}
                    helperText={errors?.directors?.[index]?.pan?.message}
                    onFileSelect={(file) => {
                      field.onChange(file);
                      handleFileSelect("panCard", index)(file);
                    }}
                  />
                )}
              />
            </Box>

            {/* Aadhar Upload */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please upload the Aadhar card
              </Typography>
              <Controller
                name={`directors[${index}].aadhar`}
                control={control}
                rules={validationRules.aadhar}
                render={({ field }) => (
                  <DragDropFileUpload
                    name="AadharCard"
                    value={convertAndSetFile(files?.AadharCard?.[index])}
                    error={!!errors?.directors?.[index]?.aadhar}
                    helperText={errors?.directors?.[index]?.aadhar?.message}
                    onFileSelect={(file) => {
                      field.onChange(file);
                      handleFileSelect("AadharCard", index)(file);
                    }}
                  />
                )}
              />
            </Box>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};

export default DirectorDocumentSet;
